import { SchemaWidgetInstance } from '../SchemaWidgetClass'

export const bookJson = (data: SchemaWidgetInstance, _page: unknown) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Book',
    name: data.get('name'),
    description: data.get('description'),
    author: {
      '@type': 'Person',
      name: data.get('authorName'),
    },
    publisher: {
      '@type': 'Organization',
      name: data.get('organizationName'),
    },
    accesMode: data.get('accessMode'),
    bookFormat: data.get('bookFormat'),
    isbn: data.get('isbn'),
    datePublished: data.get('datePublished')?.toISOString(),
    inLanguage: data.get('availableLanguage'),
    url: data.get('url'),
  }
}
